module.exports = __webpack_public_path__ + "static/media/ni.0b4fcfd3.png";